module.exports = __webpack_public_path__ + "img/renliziyuanfuwu.1b2ccad7.png";